var _circle, _circle2, _rect, _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _path7, _polygon, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _rect2, _polygon2, _path17, _rect3, _rect4, _rect5, _rect6, _path18, _path19, _path20, _polygon3, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _path33, _rect14, _rect15, _path34, _path35, _path36, _rect16, _path37, _ellipse2, _path38, _path39, _path40, _rect17, _path41, _ellipse3, _path42, _path43;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrainstormingTwoColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    "data-imageid": "brainstorming-two-color",
    imageName: "Brainstorming",
    className: "illustrations_image",
    style: {
      width: 183
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "#113_brainstorming_twocolour") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51.27,
    cy: 58.24,
    r: 20.04,
    fill: "#ffd200",
    opacity: 0.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 355.32,
    cy: 36.85,
    r: 20.04,
    fill: "#ffd200",
    opacity: 0.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 104.39,
    y: 66.47,
    width: 193.32,
    height: 134.91,
    fill: "#e6e6e6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M271.48,83.24s-3.24-.3-3.16,6.71S274,102,274,102l-1.43,12.71s-31.88-7.31-36.13,14.49-2.2,37.65-16.25,30.3-20.45-37.57-20.45-37.57-9.05-1.07-6.05,9.38,2.75,49.55,24.75,51.37,36.5,5.15,34,18.73h47.29V152.6l-18-52L279.76,87Z",
    opacity: 0.08
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M113.55,127.73s6.52-2,7.36,7.83,8.42,15.14,10.67,25.53,17.49-.7,24.6,14.24c0,0,11.93-11.16,20.89-4.42s-9,7.36-9,7.36l-7.9,19.83,23.58.31,7.57-26.2,6.41,1-6.13,28.18-68.55-1.16-9.53-43.39L108.44,141Z",
    opacity: 0.08
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M144.08,204.91l20.43-33.65s7.63,0,8.9-3.09c.79-1.93-3.95-2.43-7.62-2.54a8.92,8.92,0,0,0-6.64,2.71L134,194.11S129.07,209.52,144.08,204.91Z",
    fill: "#f4a28c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M144.08,204.91l20.43-33.65s7.63,0,8.9-3.09c.79-1.93-3.95-2.43-7.62-2.54a8.92,8.92,0,0,0-6.64,2.71L134,194.11S129.07,209.52,144.08,204.91Z",
    opacity: 0.08
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M172.2,220.24s7.36,6.94-2.18,6.66S164,219.2,172.2,220.24Z",
    fill: "#fad347",
    className: "target-color"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M113.76,141.48s14.26,10.66,7.54,14.78-11.92-15.78-11.92-15.78Z",
    fill: "#24285b"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 193.6,
    cy: 263.03,
    rx: 145.07,
    ry: 15.64,
    fill: "#e6e6e6",
    opacity: 0.45
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M113.69,132.38a29.06,29.06,0,0,1,.75,7.69,2.33,2.33,0,0,1-2.58,2.07,5.15,5.15,0,0,1-4.55-3.25l-2-3.82a4.15,4.15,0,0,1,1.17-4.67C108.84,128.15,113.18,129.59,113.69,132.38Z",
    fill: "#f4a28c"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "105.73 137.44 107.16 152.6 115.46 151.21 111.09 140.74 105.73 137.44",
    fill: "#f4a28c"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M109.38,137s-.29-1.76-1.6-1.43-.9,2.89.94,2.86Z",
    fill: "#f4a28c"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M114.22,135.27l1.54,1.58a.74.74,0,0,1-.29,1.22l-1.71.59Z",
    fill: "#f4a28c"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M144.75,207.83s28.39-7.2,32.09,5.35-39.7,11.31-39.7,11.31l-9.88-7.82Z",
    fill: "#24285b"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M115.46,151.21s16.53,1.69,28.05,14.85c6.85,7.82,4.26,14.33,1,18.33a13.18,13.18,0,0,0-2.16,12.31l3.42,10.67S127.52,219.14,116,217.91,68.07,153,115.46,151.21Z",
    fill: "#fad347",
    className: "target-color"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M93,164.59A28.68,28.68,0,0,0,92,176.92c1.1,6.06,6.84,46.32,44.73,35.45l9.05-5-9.6-8.12L117.82,180l-8-15.44Z",
    opacity: 0.08
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M105.94,191.79c-8.12-24.61-44.4-20.58-47.5,5.15-3.21,26.57.42,63.23,43.19,68,68,7.56,78.73-23.16,69.13-39.35s-57.33-7.68-64.46-32.64C106.18,192.55,106.07,192.17,105.94,191.79Z",
    fill: "#e6e6e6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M162,205.66s9.48,2.3,10.17-3.74l-10.36-.55Z",
    fill: "#f4a28c"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M104.39,165.29a7.2,7.2,0,0,1,11-6.24c3.25,2.15,6.46,6.58,8.39,15.27,3.77,17,13.18,24.31,38.22,26.51v4.83S105.4,220.06,104.39,165.29Z",
    fill: "#f4a28c"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M112.75,133.49h0a3.38,3.38,0,0,0,.8-5.76,7.39,7.39,0,0,0-1.67-1c-4-1.65-13.42-.49-12.8,8.5s-14.38,29.42-.83,35,24.83-1.79,24.83-8.37-12.85-8.16-13.7-13.92c-.34-2.35-.67-4.84-.94-7A7.16,7.16,0,0,1,112.75,133.49Z",
    fill: "#24285b"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 155.95,
    y: 198.1,
    width: 29.35,
    height: 4.22,
    fill: "#ffd200"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "181.44 200.22 190.92 169.07 193.64 169.69 185.3 202.32 181.44 200.22",
    fill: "#ffd200"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M82.05,230.09c-4.78-4.37-12.28.42-10.21,6.56,2.93,8.67,9.66,17.19,24.45,19.71,33.23,5.65,30-6.64,27.85-12C122.39,240,100.38,246.81,82.05,230.09Z",
    fill: "#fff",
    opacity: 0.45
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 187.54,
    y: 119.79,
    width: 24.3,
    height: 4.21,
    fill: "#a5a5a5",
    opacity: 0.39
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 187.54,
    y: 129.16,
    width: 24.3,
    height: 4.21,
    fill: "#a5a5a5",
    opacity: 0.18
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 230.3,
    y: 119.79,
    width: 24.3,
    height: 4.21,
    fill: "#a5a5a5",
    opacity: 0.39
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 230.3,
    y: 129.16,
    width: 24.3,
    height: 4.21,
    fill: "#a5a5a5",
    opacity: 0.18
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M267.87,117.08a10.66,10.66,0,0,0-15.93-.14,42.06,42.06,0,0,0-10.89,27.64c-.71,23.71-17.46,21.36-34.87-17.45l-8.42,4.6s23.06,76.67,58.29,33.19C277.5,138.46,273.94,124.19,267.87,117.08Z",
    fill: "#fad347",
    className: "target-color"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M264.22,113.72a7.51,7.51,0,0,0-9.5.46,41.78,41.78,0,0,0-13.67,30.4c-.71,23.71-17.46,21.36-34.87-17.45l-8.42,4.6s23.06,76.67,58.29,33.19C281.66,133.33,271.62,119.12,264.22,113.72Z",
    opacity: 0.08
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M274.67,87.49s-.73,5.53,0,9.27A2.79,2.79,0,0,0,278,98.93a6.17,6.17,0,0,0,5-4.44l1.89-4.8a5,5,0,0,0-2-5.45C280,81.84,274.94,84.09,274.67,87.49Z",
    fill: "#f4a28c"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "284.63 90.56 286.7 108.74 276.6 109.17 279.15 95.77 284.63 90.56",
    fill: "#f4a28c"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M276,87.78a21.71,21.71,0,0,0,5.16-.17,4.67,4.67,0,0,0-.23,5.11,3.79,3.79,0,0,0,4.51,1.71l.23-7.17a5.67,5.67,0,0,0-2.66-5.19,19.43,19.43,0,0,0-2.34-1.28c-2-.92-5.11.33-6.9-1.15a1.35,1.35,0,0,0-2.17.79c-.42,2.16-.18,5.61,2.72,6.93A5.13,5.13,0,0,0,276,87.78Z",
    fill: "#24285b"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M280.38,92.53s.14-2.15,1.75-1.91,1.42,3.33-.78,3.53Z",
    fill: "#f4a28c"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M274.39,91l-1.65,2.08a.9.9,0,0,0,.49,1.43l2.12.49Z",
    fill: "#f4a28c"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M278.46,98.68a6.71,6.71,0,0,0,3.36-1.8s-.3,3.33-4.11,6.47Z",
    fill: "#ce8172",
    opacity: 0.31
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M266.18,109s37.53-8.41,51-.87-12.94,78.56-12.94,78.56l-41.44-1.31S226.51,116.17,266.18,109Z",
    fill: "#fad347",
    className: "target-color"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M274.56,253.34s-1.93,3.48-5.32,3.22-4.78,2.86-1.92,4.19,11.23-1.26,11.23-1.26l.72-6.15Z",
    fill: "#fad347",
    className: "target-color"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M304.92,252.57s1.37,3.73,4.75,4,4.3,3.56,1.27,4.45S300,258,300,258l.23-6.19Z",
    fill: "#fad347",
    className: "target-color"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M204.41,128.1s.52-8.57-5-10.72,0,13.44,0,13.44Z",
    fill: "#f4a28c"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M298.76,114.67s-11.85,7.69-5.82,25.23,7,30.13-7.22,25.73-13.2-24-13.2-24L258,143.83l-1.4,27.88,6.17,13.63,36-2.26,14.67-3.75L318.9,161l-10-31.16Z",
    opacity: 0.08
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M262.77,185.34l10.6,68h6.93s-6.42-51.14,4.79-57.31,13.41,57.31,13.41,57.31l7.35-.59-.08-70.11Z",
    fill: "#24285b"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M306.08,105.86s23.35-3.94,23.35,32.8-5.62,69.44-59.5,36.67l4.1-6.26s29,12.78,35.19,1.56S285,112.09,306.08,105.86Z",
    fill: "#fad347",
    className: "target-color"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M306.08,105.86s23.35-3.94,23.35,32.8-5.62,69.44-59.5,36.67l4.1-6.26s29,12.78,35.19,1.56S285,112.09,306.08,105.86Z",
    fill: "#fff",
    opacity: 0.46
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 187.54,
    y: 89.95,
    width: 24.3,
    height: 21.37,
    fill: "#ffd200"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 196.99,
    y: 84.6,
    width: 5.87,
    height: 11.93,
    fill: "#fff",
    opacity: 0.46
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 143.8,
    y: 89.95,
    width: 24.3,
    height: 21.37,
    fill: "#a5a5a5"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 153.24,
    y: 84.6,
    width: 5.87,
    height: 11.93,
    fill: "#fff",
    opacity: 0.46
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 230.3,
    y: 89.95,
    width: 24.3,
    height: 21.37,
    fill: "#a5a5a5"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 247.05,
    y: 140.56,
    width: 20.38,
    height: 30.51,
    transform: "translate(-30.24 67.47) rotate(-14.12)",
    fill: "#ffd200"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 239.75,
    y: 84.6,
    width: 5.87,
    height: 11.93,
    fill: "#fff",
    opacity: 0.46
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M274,169.07s-9.73-7.7-11.26-1.81,8.56,5.93,8.56,5.93Z",
    fill: "#f4a28c"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 143.8,
    y: 119.79,
    width: 24.3,
    height: 4.21,
    fill: "#a5a5a5",
    opacity: 0.39
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 143.8,
    y: 129.16,
    width: 24.3,
    height: 4.21,
    fill: "#a5a5a5",
    opacity: 0.18
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M367.73,39.16a12.59,12.59,0,1,0-23.19,3,10.15,10.15,0,0,1,.92,7.5l-.1.42,12.07,3.09.08-.31a10.22,10.22,0,0,1,4.6-6.13A12.59,12.59,0,0,0,367.73,39.16Z",
    fill: "#ffd200"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M348.24,50.87a.43.43,0,0,1-.33-.46l1.4-16.09a.44.44,0,0,1,.48-.4.42.42,0,0,1,.39.47l-1.4,16.09a.43.43,0,0,1-.47.4Z",
    fill: "#fff"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M354.6,52.5l-.07,0a.44.44,0,0,1-.22-.58l6.5-14.78a.43.43,0,0,1,.58-.23.44.44,0,0,1,.22.58l-6.5,14.78A.45.45,0,0,1,354.6,52.5Z",
    fill: "#fff"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 343.47,
    y: 49.63,
    width: 14.27,
    height: 11.26,
    transform: "translate(24.67 -85.24) rotate(14.36)",
    fill: "#24285b"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M356,39.37A2.1,2.1,0,0,1,354.7,38c-.13-.31-.3-.48-.48-.51-.42-.07-1.06.48-1.3.75a.44.44,0,0,1-.66-.58c.11-.12,1.09-1.2,2.1-1a1.56,1.56,0,0,1,1.15,1c.16.36.41.81.77.86s.88-.39,1-.55a.44.44,0,1,1,.67.56,2.25,2.25,0,0,1-1.82.86Z",
    fill: "#fff"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 361.51,
    cy: 30.43,
    rx: 3.06,
    ry: 3.91,
    transform: "translate(115.87 297.4) rotate(-52.19)",
    fill: "#fff",
    opacity: 0.21
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M63.77,56.44A12.6,12.6,0,1,0,42.72,66.63,10.14,10.14,0,0,1,46,73.46l0,.43L58.43,73l0-.31a10.17,10.17,0,0,1,2.43-7.27A12.56,12.56,0,0,0,63.77,56.44Z",
    fill: "#ffd200"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M49,73.7a.42.42,0,0,1-.45-.33L44.77,57.65a.43.43,0,0,1,.32-.52.44.44,0,0,1,.53.32l3.74,15.71a.44.44,0,0,1-.33.53Z",
    fill: "#fff"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M55.52,73.24h-.08a.44.44,0,0,1-.39-.48l1.51-16.08a.43.43,0,0,1,.48-.39.44.44,0,0,1,.39.48L55.92,72.85A.43.43,0,0,1,55.52,73.24Z",
    fill: "#fff"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 45.46,
    y: 71.49,
    width: 14.27,
    height: 11.26,
    transform: "translate(-5.27 3.87) rotate(-4.01)",
    fill: "#24285b"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M52.71,60.34a2.1,2.1,0,0,1-1.66-.88c-.23-.25-.44-.37-.62-.34-.42.07-.86.79-1,1.13a.43.43,0,0,1-.57.23.43.43,0,0,1-.24-.57c.07-.15.66-1.49,1.67-1.65a1.5,1.5,0,0,1,1.41.62c.27.3.65.64,1,.58s.71-.65.79-.85a.44.44,0,0,1,.82.32c0,.12-.5,1.22-1.46,1.39Z",
    fill: "#fff"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 55.12,
    cy: 50.12,
    rx: 3.06,
    ry: 3.91,
    transform: "translate(-10.48 85.42) rotate(-70.57)",
    fill: "#fff",
    opacity: 0.21
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M304.39,96.88s46.21,25,43.52-32.67",
    fill: "none",
    stroke: "#a5a5a5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    strokeDasharray: "2 10",
    opacity: 0.32
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M52,90s-19.84,55.69,35.66,59.22",
    fill: "none",
    stroke: "#a5a5a5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    strokeDasharray: "2 10",
    opacity: 0.32
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrainstormingTwoColor);
export default __webpack_public_path__ + "static/media/brainstorming-two-color.92ba1464faecd3954332d21e645feda4.svg";
export { ForwardRef as ReactComponent };